module.exports = ":host {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex: 1;\n      flex: 1; }\n  :host /deep/ > ng-component {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex: 1;\n        flex: 1; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/shared/section/section.component.scss
// module id = 63
// module chunks = 0